module.exports = __webpack_public_path__ + "img/cubo.ea4f83da.svg";